import React from "react";

type GrowthRateSliderProps = {
    value: number;
    min?: number;
    max?: number;
    endLabel?: string;
} & Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    "type" | "value"
>;

const GrowthRateSlider = (props: GrowthRateSliderProps) => {
    const { value, onChange, endLabel, min = 0, max = 100, ...rest } = props;
    const percentage = Number(value || 0);

    // Calculate the actual percentage relative to the max value
    const actualPercentage = max !== 100 ? (percentage / max) * 100 : percentage;

    return (
        <div className="relative w-full py-10 h-16">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 646 50"
                preserveAspectRatio="none"
                className="absolute top-0 left-0 w-full h-16 z-0"
            >
                <path
                    opacity="0.4"
                    d="M126.117 29.7297L0.321777 36.577V50H646.072V0L527.614 12.8378L383.998 20.2703L264.492 22.7015L126.117 29.7297Z"
                    fill="#E2E8F0"
                />
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 553 39"
                preserveAspectRatio="none"
                className="absolute top-0 left-0 w-full h-16 z-10"
            >
                <defs>
                    <clipPath id="clip-left-70">
                        <rect x="0" y="0" width={(553 * actualPercentage) / 100} height="39" />
                    </clipPath>

                    <linearGradient
                        id="paint0_linear_17352_121132"
                        x1="294.643"
                        y1="39"
                        x2="293.618"
                        y2="4.46523"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#62CC00" stop-opacity="0.1" />
                        <stop offset="1" stop-color="#3EA100" />
                    </linearGradient>
                </defs>
                <path
                    d="M1.32178 29L21.0896 27L35.7325 26L73.0718 24L106.75 22.5L147.018 20.5L190.947 18L219.5 17C220.965 17 229.75 16.5 229.75 16.5L245.855 15.4172C253.179 15 253.918 15.0806 262.697 14.6709C266.357 14.5 270.018 14.5 281 14L292.715 13.5L308.09 13C317.249 12.6076 321.939 12.6803 331.518 12.5H341.768C351.927 12.3088 356.985 12.4922 366.661 12.0629L384.965 11.5C392.26 11.1763 422.675 9.4515 429.517 9L528.465 4L553.357 1.5"
                    stroke="#3EA100"
                    stroke-width="2"
                    stroke-linecap="round"
                    clipPath="url(#clip-left-70)"
                />

                <path
                    opacity="0.4"
                    d="M126.261 19.1248L0.321777 25.8386V39H552.357V0L528.219 2.56204L384.438 9.84964L264.795 12.2335L126.261 19.1248Z"
                    fill="url(#paint0_linear_17352_121132)"
                    clipPath="url(#clip-left-70)"
                />
            </svg>

            <input
                type="range"
                min={min}
                max={max}
                value={percentage}
                onChange={onChange}
                className="w-full relative z-10 -bottom-[10px] 
                appearance-none 
                bg-[#0F846D] 
                rounded-[5px] 
                h-[3px] 
                shadow-xl/20 
                [&::-webkit-slider-thumb]:appearance-none 
                [&::-webkit-slider-thumb]:w-[10px] 
                [&::-webkit-slider-thumb]:h-[10px] 
                [&::-webkit-slider-thumb]:rounded-full 
                [&::-webkit-slider-thumb]:bg-[#0F846D]  
                [&::-webkit-slider-thumb]:shadow-xl/20
                [&::-webkit-slider-thumb]:cursor-pointer 
                [&::-webkit-slider-thumb]:ring-4
                [&::-webkit-slider-thumb]:ring-white
                [&::-webkit-slider-thumb]:z-[10000]
                [&::-moz-range-thumb]:w-[10px] 
                [&::-moz-range-thumb]:h-[10px] 
                [&::-moz-range-thumb]:shadow-xl/20 
                [&::-moz-range-thumb]:rounded-full 
                [&::-moz-range-thumb]:bg-[#ffffff] 
                [&::-moz-range-thumb]:border-4
                [&::-moz-range-thumb]:border-[#ffffff] 
                [&::-moz-range-thumb]:cursor-pointer"
                {...rest}
            />

            <div
                className="absolute -bottom-[15px] flex items-center gap-[2px] text-sm font-rocGroteskMedium z-30"
                style={{
                    left: `calc(${actualPercentage}% - ${actualPercentage > 80 ? 87 : 14}px)`,
                }}
            >
                {percentage}% {endLabel}
            </div>
        </div>
    );
};

export default GrowthRateSlider;
